import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import { FormattedMessage } from "react-intl";

import { siteConfig } from "./settings/config";

export class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <SpashScreenWrapper id="splash-container" className={"splashContainer" + (this.props.show ? "" : " hidden")}>
        <div id="splash-content" className="splashContent">
          <div className="splashLogo">
            <img src={siteConfig?.[this.props.theme?.splashLogo ?? this.props.theme?.topbarLogo ?? ""]} alt="" />
          </div>
        </div>
        <div id="splash-footer" className="splashFooter">
          <FormattedMessage id={siteConfig.footerText} />
        </div>
      </SpashScreenWrapper>
    );
  }
}

export default withTheme(SplashScreen);

const SpashScreenWrapper = styled.div`
  height: 100vh;
  width: 100vw;

  display: grid;
  grid-template-rows: calc(100vh - 70px) 70px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;

  background-color: ${props => props.theme.color?.["Splash Background"] ?? "#e5e5e5"};
  visibility: visible;
  opacity: 1;
  transition: opacity 0.75s ease-in;

  &.hidden {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.75s, opacity 0.75s ease-in;
    pointer-events: none;
  }

  .splashContent {
    max-width: 500px;
    width: 100%;
    margin: 0 auto;

    display: flex;
    align-items: center;

    .splashLogo > img {
      width: 100%;
    }
  }

  .splashFooter {
    padding: 24px 50px;
    text-align: center;
    color: ${props => props.theme.color?.["Splash Footer Text"] ?? "inherit"};
  }
`;
